export default (consult) => {
  if (consult.patAvatar) {
    return consult.patAvatar
  }
  else if (consult.consulterGender) {
    return `./static/img/pat.${consult.consulterGender.toLowerCase()}.jpg`
  }
  else if (consult.patGender) {
    return `./static/img/pat.${consult.patGender.toLowerCase()}.jpg`
  }
  else if (consult.replierAvatar) {
    return consult.replierAvatar
  }
  else {
    return `./static/img/pat.m.jpg`
  }
}



// WEBPACK FOOTER //
// ./src/utils/consultPatAva.js